import React from 'react';

const WebpageIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="67" height="67" viewBox="0 0 67 67" fill="none">
            <rect width="67" height="67" fill="#F5F5F5" />
            <mask id="mask0_2569_175" maskUnits="userSpaceOnUse" x="9" y="10" width="48" height="48">
                <rect x="9" y="10" width="48" height="48" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_2569_175)">
                <path
                    d="M11.85 50C11.0663 50 10.3953 49.7062 9.837 49.1185C9.279 48.5312 9 47.825 9 47H16.05C15.25 47 14.55 46.7 13.95 46.1C13.35 45.5 13.05 44.8 13.05 44V19C13.05 18.2 13.35 17.5 13.95 16.9C14.55 16.3 15.25 16 16.05 16H49.95C50.75 16 51.45 16.3 52.05 16.9C52.65 17.5 52.95 18.2 52.95 19V44C52.95 44.8 52.65 45.5 52.05 46.1C51.45 46.7 50.75 47 49.95 47H57C57 47.8333 56.7063 48.5417 56.119 49.125C55.5313 49.7083 54.825 50 54 50H11.85ZM33 48.9C33.4817 48.9 33.8855 48.7372 34.2115 48.4115C34.5372 48.0855 34.7 47.6817 34.7 47.2C34.7 46.7183 34.5372 46.3145 34.2115 45.9885C33.8855 45.6628 33.4817 45.5 33 45.5C32.5183 45.5 32.1145 45.6628 31.7885 45.9885C31.4628 46.3145 31.3 46.7183 31.3 47.2C31.3 47.6817 31.4628 48.0855 31.7885 48.4115C32.1145 48.7372 32.5183 48.9 33 48.9ZM16.05 44H49.95V19H16.05V44Z"
                    fill="#B4B4B4"
                />
            </g>
        </svg>
    );
};

export default WebpageIcon;
